import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot
} from '@angular/router';

import { HttpClient } from '@angular/common/http';

import {
    Observable,
    of,
    switchMap
} from 'rxjs';
import { SeoService } from '../services/seo.service';
import { SeoData } from '../interfaces/seo.interface';
import { environment } from '@src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SeoResolver implements Resolve<boolean> {

    constructor(
        private http: HttpClient,
        private seoService: SeoService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> {

        const currentUrl = state.url;
        const parsed_record = currentUrl.replace('/', '') 
        const seoKey = parsed_record.split('?')[0];
        const refId = route.queryParamMap.get('ref_id');
        if(refId) {
            localStorage.setItem("agent_id",refId)
        }
        return this.http
            .get<Record<string, SeoData>>(`/assets/tenant-assets/seo/seo.json?v=1.1`)
            .pipe(
                switchMap((seoConfig) => {
                    const seoData = seoConfig[seoKey] || seoConfig['default'];
                    if (seoData) {
                        this.seoService.updateSeoTags(seoData);
                    }
                    return of(true);
                })
            );
    }
}